import { render, staticRenderFns } from "./BatchLoader.vue?vue&type=template&id=70507842&"
import script from "./BatchLoader.vue?vue&type=script&lang=js&"
export * from "./BatchLoader.vue?vue&type=script&lang=js&"
import style0 from "./BatchLoader.vue?vue&type=style&index=0&id=70507842&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70507842')) {
      api.createRecord('70507842', component.options)
    } else {
      api.reload('70507842', component.options)
    }
    module.hot.accept("./BatchLoader.vue?vue&type=template&id=70507842&", function () {
      api.rerender('70507842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/HotelBatchLoader/BatchLoader.vue"
export default component.exports